import React, {Component} from 'react';

export default class Page404 extends Component {
  componentDidMount() {
    document.body.classList.add('page-404');
  }

  componentWillUnmount() {
    document.body.classList.remove('page-404');
  }

  render() {
    return (
      <div className="page-not-found">
        <div className="page-not-found-wrapper">
          <i className="icon-b icon-b-exclamation" />
          <h1>404</h1>
          <div className="message">Sorry, page not found.</div>
        </div>
      </div>
    );
  }
}
